import { useTranslation } from 'react-i18next';
import { LOGIN_COLORS } from '../../constants/login-theme';

const loginHeroGlobe = '/assets/images/login-hero-globe.svg';

export const LoginHeroPanel = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative isolate h-full min-h-[calc(100dvh-1.5rem)] w-full overflow-hidden rounded-[inherit]"
      style={{ backgroundColor: LOGIN_COLORS.heroBg }}
    >
      <img
        src={loginHeroGlobe}
        alt=""
        aria-hidden
        className="pointer-events-none absolute -bottom-10 -left-12 w-56 max-w-none select-none sm:w-64 lg:w-72 xl:w-80"
      />

      <div className="relative z-10 flex h-full flex-col p-10">
        <div className="mt-6 max-w-xl">
          <h1
            className="text-[3rem] font-bold leading-[1.15] tracking-tight"
            style={{ color: LOGIN_COLORS.heroTitle }}
          >
            {t('WELCOME_TEXT')}
            <br />
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage: `linear-gradient(90deg, ${LOGIN_COLORS.heroGradientFrom}, ${LOGIN_COLORS.heroGradientTo})`,
              }}
            >
              {t('WELCOME_TEXT_GRADIENT')}
            </span>
          </h1>
          <p
            className="mt-6 max-w-md text-xl font-normal leading-8"
            style={{ color: LOGIN_COLORS.heroTagline }}
          >
            {t('WELCOME_DESCRIPTION')}
          </p>
        </div>
      </div>
    </div>
  );
};
